import { useEffect } from "react";
import { useMap } from "react-leaflet";
import { maplibreGL } from "@maplibre/maplibre-gl-leaflet";
import "maplibre-gl/dist/maplibre-gl.css";

// OpenFreeMap: free vector tiles, no API key, no usage limits.
const STYLE_URL = "https://tiles.openfreemap.org/styles/liberty";
const ATTRIBUTION =
  '<a href="https://openfreemap.org" target="_blank">OpenFreeMap</a> &copy; <a href="https://www.openmaptiles.org/" target="_blank">OpenMapTiles</a> Data from <a href="https://www.openstreetmap.org/copyright" target="_blank">OpenStreetMap</a>';

export default function BaseMap() {
  const map = useMap();

  useEffect(() => {
    const layer = maplibreGL({
      style: STYLE_URL,
      attributionControl: { customAttribution: ATTRIBUTION },
    });
    layer.addTo(map);
    return () => {
      map.removeLayer(layer);
    };
  }, [map]);

  return null;
}
